'use client'

import { Common } from '@/config/NextImport'
import { useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'

const HomeBanner = (props: any) => {
  const router = useRouter()
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 1024)
    }

    checkScreen()
    window.addEventListener('resize', checkScreen)

    return () => window.removeEventListener('resize', checkScreen)
  }, [])

  const Navigate = (link: string, type: any) => {
    if (!link) return

    if (type === 'external_link') {
      window.open(link, '_blank')
    } else {
      router.push(link)
    }
  }

  if (!props?.data || props.data.length === 0) {
    return (
      <section className="banner-section">
        <img
          src={Common.setImagePath('assets/images/imagenotfound.jpg')}
          alt="404 Not Found"
        />
      </section>
    )
  }

  const banner = props.data[0]
  const desktopSrc = banner.desktop_main_image
  const mobileSrc = banner.mobile_main_image

  const btnTheme = isMobile ? banner.mob_btn_theme : banner.desk_btn_theme

  const getBtnClass = () => {
    if (btnTheme === 'white') return 'btn btn-outline-light'
    if (btnTheme === 'black') return 'btn btn-outline-dark'
    return 'btn btn-custom'
  }

  return (
    <section className="banner-section">
      <div
        className="banner-video"
        style={{ position: 'relative' }}
      >
        {/* First Button */}
        {banner.btn_text && (
          <button
            className={getBtnClass()}
            style={{
              position: 'absolute',
              left: `${isMobile ? banner.mob_btn_x_position : banner.desk_btn_x_position}%`,
              top: `${isMobile ? banner.mob_btn_y_position : banner.desk_btn_y_position}%`,
              transform: 'translate(-50%, -50%)',
              zIndex: 10,
              width: isMobile ? '250px' : '',
              fontSize: isMobile ? '14px' : '16px',
              padding: isMobile ? '8px 14px' : '10px 24px'
            }}
            onClick={() => Navigate(banner.link, banner.type)}
          >
            {banner.btn_text}
          </button>
        )}

        {/* Second Button */}
        {banner.btn_text_2 && (
          <button
            className={getBtnClass()}
            style={{
              position: 'absolute',
              left: `${isMobile ? banner.mob_btn_x_position_2 : banner.desk_btn_x_position_2}%`,
              top: `${isMobile ? banner.mob_btn_y_position_2 : banner.desk_btn_y_position_2}%`,
              transform: 'translate(-50%, -50%)',
              zIndex: 10,
              width: isMobile ? '250px' : '',
              fontSize: isMobile ? '14px' : '16px',
              padding: isMobile ? '8px 14px' : '10px 24px'
            }}
            onClick={() => Navigate(banner.link_2, banner.type_2)}
          >
            {banner.btn_text_2}
          </button>
        )}

        {/* Banner image. Buttons stay on the existing client breakpoint so tablet
            and phone placement does not change. The picture source lets the
            browser pick the mobile file in the first HTML. */}
        <picture>
          {mobileSrc ? (
            <source
              media="(max-width: 1024px)"
              srcSet={mobileSrc}
            />
          ) : null}
          <img
            src={desktopSrc}
            alt="Engagement Rings"
            width={1903}
            height={820}
            fetchPriority="high"
          />
        </picture>
      </div>
    </section>
  )
}

export default HomeBanner
